import React from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import pathImg from "../../Assets/campus4.jpg"

const points = [
	{ icon: "ri-shield-star-line", text: "Exclusive boys-focused residential campus" },
	{ icon: "ri-graduation-cap-line", text: "Integrated NEET, JEE, KEAM & CUET coaching" },
	{ icon: "ri-home-heart-line", text: "Safe, supportive, and disciplined environment" },
	{ icon: "ri-user-star-line", text: "Expert mentorship & career guidance" },
	{ icon: "ri-global-line", text: "Global university pathways & exposure" },
]

const Path = () => {
	return (
		<section className="path-section-v2">
			<div className="container-main">
				<div className="path-v2-layout">
					<motion.div
						className="path-v2-image"
						initial={{ opacity: 0, x: -30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.7 }}
					>
						<img src={pathImg} alt="Students at Branmont" />
					</motion.div>

					<motion.div
						className="path-v2-content"
						initial={{ opacity: 0, x: 30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.7, delay: 0.1 }}
					>
						<span className="path-v2-eyebrow">Your Future Starts Here</span>
						<h2 className="path-v2-heading montserrat">
							Why Choose Branmont{" "}
							<span>Global Secondary School?</span>
						</h2>
						<div className="path-v2-points">
							{points.map((p, i) => (
								<motion.div
									className="path-v2-point"
									key={p.text}
									initial={{ opacity: 0, x: 16 }}
									whileInView={{ opacity: 1, x: 0 }}
									viewport={{ once: true }}
									transition={{ duration: 0.4, delay: i * 0.06 }}
								>
									<div className="path-v2-point-icon">
										<i className={p.icon}></i>
									</div>
									<span>{p.text}</span>
								</motion.div>
							))}
						</div>
						<Link className="path-v2-btn" to="/acadamics">
							Explore Programs <i className="ri-arrow-right-line"></i>
						</Link>
					</motion.div>
				</div>
			</div>
		</section>
	)
}

export default Path
